import React from 'react'; 

const Footer = () => (

	// <!-- Footer -->
	<footer class="py-3">
	
	  {/* <!-- Copyright --> */}
	  <div class="footer-copyright text-center py-3 text-white">© ALL RIGHTS RESERVED:
		<a href="#"> Tanawat Limsakul</a>
	  </div>
	  {/* <!-- Copyright --> */}
	
	</footer>
	// <!-- Footer -->

);
export default Footer;